// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"b29f5fce","214":"bf87848f"}[chunkId] + ".chunk.css";
};